import UserService from 'services/UserService';

const userService = UserService.getInstance();

function useStaff() {
  const getStaff = async ({ page = 1, perPage = 10, strFilter = '', sort = 'asc', orderBy = 'name' }: any) => {
    try {
      const res = await userService.fetchStaffList({
        page,
        per_page: perPage,
        q: strFilter,
        sort,
        order_by: orderBy,
      });
      return res;
    } catch (error) {
      return error;
    }
  };

  const getStaffQuery = async (page: number, query: string) => {
    try {
      const res = await userService.fetchStaffListQuery(page, query);
      return res;
    } catch (error) {
      return error;
    }
  };

  const getDirectorDetail = async (id: number, centerId: number) => {
    try {
      const res = await userService.fetchStaffDetail(id, centerId);
      return res;
    } catch (error) {
      return error;
    }
  };

  const addStaff = async (body: any) => {
    const res = await userService.addStaff(body);
    return res;
  };

  const deleteStaff = async (id: number) => {
    try {
      const res = await userService.deleteStaff(id);
      return res;
    } catch (error) {
      return error;
    }
  };

  return {
    getStaff,
    addStaff,
    getDirectorDetail,
    deleteStaff,
    getStaffQuery,
  };
}

export default useStaff;
